var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuProfileIconW(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.5C4.92339 0.5 0 5.42339 0 11.5C0 17.5766 4.92339 22.5 11 22.5C17.0766 22.5 22 17.5766 22 11.5C22 5.42339 17.0766 0.5 11 0.5ZM11 4.75806C13.1556 4.75806 14.9032 6.50565 14.9032 8.66129C14.9032 10.8169 13.1556 12.5645 11 12.5645C8.84435 12.5645 7.09677 10.8169 7.09677 8.66129C7.09677 6.50565 8.84435 4.75806 11 4.75806ZM11 20.0161C8.39637 20.0161 6.06331 18.8363 4.50202 16.9911C5.33589 15.421 6.96814 14.3387 8.87097 14.3387C8.97742 14.3387 9.08387 14.3565 9.18589 14.3875C9.7625 14.5738 10.3657 14.6935 11 14.6935C11.6343 14.6935 12.2419 14.5738 12.8141 14.3875C12.9161 14.3565 13.0226 14.3387 13.129 14.3387C15.0319 14.3387 16.6641 15.421 17.498 16.9911C15.9367 18.8363 13.6036 20.0161 11 20.0161Z",
    fill: "#FFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuProfileIconW);
export default __webpack_public_path__ + "static/media/menu-profile-icon-w.4c86838a02e576fd5fbc6687fa9ab076.svg";
export { ForwardRef as ReactComponent };